<template>

	<!-- 服务区域 -->
	<section class="section">
		<div class="container">
			<div class="section-title">
				<h2>我们的服务</h2>
				<p>提供全方位、专业化的财税服务，满足企业不同发展阶段的需求</p>
			</div>
			<div class="services-grid">
				<div class="service-card">
					<div class="service-icon">
						<i class="fas fa-chart-line"></i>
					</div>
					<h3>公司注册</h3>
					<p>公司注册，提供地址挂靠，信件接收，银行地址核实等，助你轻松启航。</p>
					<a href="#" class="service-link">了解更多 <i class="fas fa-arrow-right"></i></a>
				</div>
				<div class="service-card">
					<div class="service-icon">
						<i class="fas fa-file-invoice-dollar"></i>
					</div>
					<h3>代理记账</h3>
					<p>专业会计团队为企业提供准确、及时的记账服务，确保财务数据真实可靠。</p>
					<a href="#" class="service-link">了解更多 <i class="fas fa-arrow-right"></i></a>
				</div>
				<div class="service-card">
					<div class="service-icon">
						<i class="fas fa-search-dollar"></i>
					</div>
					<h3>税务审计</h3>
					<p>全面的税务审计服务，帮助企业合规经营，降低税务风险，优化税务结构。</p>
					<a href="#" class="service-link">了解更多 <i class="fas fa-arrow-right"></i></a>
				</div>
				<div class="service-card">
					<div class="service-icon">
						<i class="fas fa-chart-line"></i>
					</div>
					<h3>财务咨询</h3>
					<p>为企业提供专业的财务规划、预算管理和财务分析服务，助力企业决策。</p>
					<a href="#" class="service-link">了解更多 <i class="fas fa-arrow-right"></i></a>
				</div>
				<div class="service-card">
					<div class="service-icon">
						<i class="fas fa-chart-line"></i>
					</div>
					<h3>公司注销</h3>
					<p>为你做税务注销，工商注销，处理账务问题。</p>
					<a href="#" class="service-link">了解更多 <i class="fas fa-arrow-right"></i></a>
				</div>
			</div>
		</div>
	</section>
</template>